import { render } from "./EditCustomerReturnReason.vue?vue&type=template&id=715e448b"
import script from "./EditCustomerReturnReason.vue?vue&type=script&lang=js"
export * from "./EditCustomerReturnReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__